import { memo } from 'react';

import PropTypes from 'prop-types';

import Style from './SimpleCard.module.css';

const SimpleCard = memo(({ title, description }) => (
  <div className={`${Style.wrapper} p-24 shadow`}>
    <div className='font-14 bold m-b-10'>{title}</div>
    <div className='font-12 gray'>{description}</div>
  </div>
));

SimpleCard.displayName = 'SimpleCard';

SimpleCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default SimpleCard;
